import { Button, MenuItem } from '@blueprintjs/core';
import axios from 'axios';
import React, {PureComponent} from 'react';
import toastr from 'toastr';
import { login } from '../../../services/authService';
import http from '../../../services/httpService';
import * as userService from '../../../services/userService';
import InputRegular from '../../common/InputRegular';
import {Select} from "@blueprintjs/select";

class AddFundsStep1 extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            creditsAmount: 1000,
            fieldsCheckActive: false,
            errorsList: [],
        };
    }

    componentDidMount() {

    }

    handleGoToSecondStep = () => {
        // console.log('handleGoToSecondStep: ', this.state)
        this.setState({fieldsCheckActive: true})
        setTimeout(async () => {
            let anyErrorActive = false;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            if (!anyErrorActive) {
                this.props.handleStepChange(2)
                this.setState({errorList: [], fieldsCheckActive: false})
            }
        }, 500)
    }

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }

    render() {
        return (
            <div className='add-funds-content-container'>
                <div className='white-wrapper'>
                    <h2>Add credits to your workspace</h2>
                    <div className="space-between">
                        <span><strong>How much balance would you like to add?</strong></span>
                    </div>
                    <div style={{margin: '20px 0'}}>
                        <p htmlFor="post-link" className='full-row-label'>Choose the amount</p>
                        <Select
                            items={[1000, 2000, 3000, 5000, 10000, 15000, 30000, 'Custom']}
                            itemRenderer={item =>
                                <MenuItem
                                    key={item}
                                    text={item}
                                    onClick={() => this.props.updateCreditsAmount(item, this.props.creditsAmount)}
                                />
                            }
                            // onItemSelect={(item) => this.setState({subscriptionType: item})}
                            filterable={false}
                            // style={{width: '100%'}}
                        >
                            <Button className='country-selector' text={this.props.creditsSelector} rightIcon="caret-down"></Button>
                        </Select>
                    </div>
                    {this.props.creditsSelector === 'Custom' ?
                        <div style={{margin: '20px 0'}}>
                            <InputRegular
                                id="1"
                                label1="Type the amount"
                                label2="Minimum 1000 credits"
                                placeholder=""
                                type='value-below'
                                valueBelow={1000}
                                onChange={ value=>this.props.updateCreditsAmount(this.props.creditsSelector, value) }
                                value={this.props.creditsAmount}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="Amount can't be less than 1000 credits"
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                required={true}
                            />
                        </div>
                        :
                        ''
                    }

                    <button onClick={this.handleGoToSecondStep}>Checkout Details</button>
                    <p className='grey-text text-align-center margin-top-10'>You won't be charged yet</p>
                </div>
            </div>
        )
    }
}

export default AddFundsStep1;